module.exports = __webpack_public_path__ + "assets/img/组 539@2x.a9f87160.png";